import { connect } from 'react-redux'
import CreateNewTransferWizard from './CreateNewTransferWizard'
import {
    startNewTransferCreation,
    createNewTransfer,
} from '../../../redux/actions/transfers'

const mapStateToProps = state => {
    return {
        app_state: state.app_state,
        transfers: state.transfers,
        language: state.language,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        startNewTransferCreation: () => {
            dispatch(startNewTransferCreation())
        },
        createNewTransfer: data => {
            dispatch(createNewTransfer(data))
        },
    }
}

const CreateNewTransferWizardContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateNewTransferWizard)

export default CreateNewTransferWizardContainer
